const $collectionGroup = $('#collection-group');
let madeSelection = false;
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function selectProductGroup() {
	let variant_titles = [];
	let variant_values = [];

	$('.product__section-overlay .group-variant-selector').each(function(i){
		let _variant_title = $(this).data('variant-title');
		variant_titles.push(_variant_title);
		let _variant_value = $(this).val();
		variant_values.push(_variant_value);
	});

	let $obj;

	$('.group-product-selector').each(function(){
		const _type = $(this).data('type');
		if(_type == 'base-product') {
			let status = true;
			for(var i in variant_titles) {
				let _v_title = variant_titles[i];
				let _data_option = $(this).data(_v_title);
				if(typeof _data_option != 'undefined') {
					if(_data_option != variant_values[i]) {
						status = false;
					}
				}
			}

			if(status) {
				$obj = $(this);
			}
		}
	});

	return $obj;
}

function getProductVariantGroup() {
	const $product = selectProductGroup();

	let option_values = [];
	$('.group-option-selector').each(function(){
		let _variant_key = $(this).data('variant-key');
		if(_variant_key != "") {
			let _option_value = '';
			$('.product__section-overlay .group-variant-selector').each(function(){
				let _variant_title = $(this).data('variant-title');
				if(_variant_title == _variant_key) {
					_option_value = $(this).val();
				}
			});
			option_values.push(_option_value);
		} else {
			option_values.push($(this).val());
		}
	});
	if(option_values.length == 1) {
		option_values.push('');
		option_values.push('');
	} else if(option_values.length == 2) {
		option_values.push('');
	}

	let $selectedProductOption = false;
	if(typeof $product !== 'undefined') {
		$product.find('option').each(function(i){
			let _option1 = $(this).data('option1');
			let _option2 = $(this).data('option2');
			let _option3 = $(this).data('option3');

			if(typeof _option1 != 'undefined') {
				if(option_values[0] == _option1 && option_values[1] == _option2 && option_values[2] == _option3) {
					$selectedProductOption = $(this);
				}
			}
		});
	}

	if($selectedProductOption) {
		$product.val($selectedProductOption.val());
	}

	return $selectedProductOption;
}

function getComponentVariantGroup() {
	let selectedShelfOption = true;
	$('.group-component-selector').each(function(){
		if($(this).val() == '') {
			selectedShelfOption = false
		}
	});

	return selectedShelfOption;
}

function checkAvailableProductGroup() {
	let $selectedProductOption = getProductVariantGroup();
	let selectedShelfOption = getComponentVariantGroup();

	if($selectedProductOption && selectedShelfOption) {
		return true;
	} else {
		return false;
	}
}

function checkAddToCartGroup() {
	const $addToCartBtn = $('#AddToCart');

	const qty = parseInt($('#field-qty').val());

	// component
	let component_valid = true;
	if($('.group-component-selector').length > 0) {
		$('.group-component-selector').each(function(){
			if($(this).val() == '') {
				component_valid = false;
			}
		});
	}

	let component_qty_valid = true;
	if($('.group-orientation-numbers').length > 0) {
		$('.group-orientation-numbers:not(.hide)').each(function(){
			if($(this).val() == '0') {
				component_qty_valid = false;
			}
		});
	}

	if(qty > 0 && component_valid && component_qty_valid) {
		$('.group-component-selector').each(function(){
			$(this).siblings('span').each(function(){
				if(!$(this).hasClass('hide')) {
					$(this).addClass('hide')
				}
			});
		});

		$('.group-orientation-numbers').each(function(){
			$(this).siblings('span').each(function(){
				if(!$(this).hasClass('hide')) {
					$(this).addClass('hide')
				}
			});
		});

		let available = checkAvailableProductGroup();
		if(available) {
			$addToCartBtn.prop('disabled', false);
			$('#AddToCartText').html('Add to Cart');
		} else {
			$addToCartBtn.prop('disabled', true);
			$('#AddToCartText').html('Sold Out');
		}
	} else {
		$addToCartBtn.prop('disabled', true);
		$('#AddToCartText').html('Add to Cart');
		$('.group-component-selector').each(function(){
			if($(this).val() == '') {
				$(this).siblings('span').first().removeClass('hide').css('color', 'red');
			}
		});

		$('.group-orientation-numbers:not(.hide)').each(function(){
			if($(this).val() == '0') {
				$(this).siblings('span').first().removeClass('hide').css('color', 'red');
			}
		});
	}
}

function checkOrientationGroup() {
	let orientation = '';
	if($('#group-orientation-selector').length > 0) {
		orientation = $('#group-orientation-selector').val();
	}
	const $product = selectProductGroup();

	if(orientation != '') {
		const numbers = parseInt($product.data(orientation));

		$('.group-orientation-numbers').each(function(){
			var $parent = $(this).parents('.select')
			if($(this).data('orientation') == orientation) {
				if($parent.hasClass('hidden')) {
					let _option_html = '<option value="0"></option>';
					for(var i = 1; i < numbers + 1; i++) {
						_option_html += '<option value="' + i + '">' + i + '</option>';
					}
					$(this).html(_option_html);
					$(this).selectric('refresh');
					$parent.removeClass('hidden');
				}
			} else {
				if(!$parent.hasClass('hidden')) {
					$parent.addClass('hidden');
				}
			}
		});
	}
}

function getComponentVariantObj(component_id) {
	let $product = $('.group-product-selector[data-product-id="' + component_id + '"]');
	let rel_key = $product.data('relation-variant');
	let variant_value = '';
	$('.product__section-overlay .group-variant-selector').each(function(){
		let _has_rel = $(this).data('relation');
		let _rel_key = $(this).data('variant-title');
		if(_has_rel && rel_key == _rel_key) {
			variant_value = $(this).val();
		}
	});

	let $variant;
	if(variant_value != '') {
		let $variantObj = false;

		if(rel_key.includes('size')) {
			let orientation = '';
			if($('#group-orientation-selector').length > 0) {
				orientation = $('#group-orientation-selector').val();
				let orientation_index = 0;
				$('#group-orientation-selector option').each(function(i){
					if(orientation == $(this).val()) {
						orientation_index = i;
					}
				});

				let _variant_values = variant_value.split('-');
				let _v = _variant_values[0];
				if(orientation_index == 1) {
					_v = _variant_values[_variant_values.length - 1];
				}

				$product.find('option').each(function(){
					let _option1 = $(this).data('option1').split('-');
					if(_v == _option1[0]) {
						$variantObj = $(this);
					}
				});

				if($variantObj) {
					$product.val($variantObj.val());
					$variant = $variantObj;
				}
			} else {
				$product.find('option').each(function(){
					if(variant_value == $(this).data('option1')) {
						$variantObj = $(this);
					}
				});
				if($variantObj) {
					$product.val($variantObj.val());
					$variant = $variantObj;
				}
			}
		} else {
			$product.find('option').each(function(){
				if(variant_value == $(this).data('option1')) {
					$variantObj = $(this);
				}
			});
			if($variantObj) {
				$product.val($variantObj.val());
				$variant = $variantObj;
			}
		}
	}

	return $variant;
}

function calculateGroupPrice() {
	const qty = parseInt($('input[name="quantity"]').val());

	const $product = selectProductGroup();
	let variant_id = 0;
	let variant_price = 0;
	if(typeof $product !== 'undefined') {
		variant_id = $product.val();
		$product.find('option').each(function(){
			let _variant_id = $(this).val();
			if(variant_id == _variant_id) {
				variant_price = parseInt($(this).data('price')) * qty;
			}
		});
	}

	// component prices
	let component_prices = 0;
	$('.group-component-selector').each(function(){
		var _component_id = parseInt($(this).val());
		if(_component_id != '') {
			var _comp_index = $(this).data('index');
			var _qty = qty;
			if($('.group-orientation-numbers').length > 0) {
				var _orient_qty = 1;
				$('.group-orientation-numbers').each(function(){
					if(!$(this).parents('.select').hasClass('hidden')) {
						var _orientation = $('#group-orientation-selector').val();
						var _orientation_item = $(this).data('orientation');
						if(_orientation == _orientation_item) {
							_orient_qty = parseInt($(this).val());
						}
					}
				});

				_qty = _qty * _orient_qty;
			}
			var $_variantObj = getComponentVariantObj(_component_id);
			if(typeof $_variantObj != 'undefined') {
				var _variant_price = parseInt($_variantObj.data('price'));
				component_prices += _variant_price * _qty;
		  }
		}
	});

	// add-ons prices
	let addons_prices = 0;
  $('.group-addon-selector').each(function(){
  	var _addon_id = parseInt($(this).val());
    $(this).find('option').each(function(){
    	let _price = parseInt($(this).data('price'));
    	if(_addon_id == parseInt($(this).val())) {
	    	addons_prices += _price * qty;
	    }
    });
  });

  let new_item_price = variant_price + component_prices + addons_prices;
  $('.product__form-container--header .product__form--price .price').text(Shopify.formatMoney(new_item_price));
  $('.product__section-overlay .form__actions-right .total__cost-price').text(Shopify.formatMoney(new_item_price));
}

function checkHasDisabled($obj) {
	// check disabled products for add-ons
	if($obj.hasClass('group-addon-selector')) {
		let checkableDisabled = false;
		let selVal = $obj.val();

    $obj.find('option').each(function(){
    	let _price = parseInt($(this).data('price'));
    	let _value = $(this).val();
    	if(selVal == _value) {
	    	if(_price == 0) {
	    		checkableDisabled = true;
	    	}
	    }
    });

		let disabled_products = $obj.data('disabled-products');
		if(checkableDisabled && disabled_products != '') {
			let disabled_products_arr = disabled_products.split(',');
			for( var i in disabled_products_arr) {
				let _handle = disabled_products_arr[i];
				if(_handle != '') {
					$('.group-addon-selector').each(function(){
						let data_handle = $(this).data('handle');
						if(_handle == data_handle) {
							$(this).prop('disabled', true).selectric('refresh');
						}
					});
				}
			}
		} else {
			let disabled_products_arr = disabled_products.split(',');
			for( var i in disabled_products_arr) {
				let _handle = disabled_products_arr[i];
				if(_handle != '') {
					$('.group-addon-selector').each(function(){
						let data_handle = $(this).data('handle');
						if(_handle == data_handle) {
							$(this).prop('disabled', false).selectric('refresh');
						}
					});
				}
			}
		}
	}
}

if($collectionGroup.length > 0) {

	$collectionGroup.find('select').on('change', function(e){
		e.preventDefault();

		if($(this).hasClass('group-variant-selector') || $(this).hasClass('group-orientation-selector') || $(this).hasClass('group-component-selector') || $(this).hasClass('group-option-selector')) {
			checkOrientationGroup();
			checkAddToCartGroup();
		} else if($(this).hasClass('group-orientation-numbers')) {
			checkAddToCartGroup();
		}
		
		let selVal = $(this).val();
		if($(this).hasClass('group-variant-selector')) {
			let variant_title = $(this).data('variant-title');
			$collectionGroup.find('select.group-variant-selector').each(function(){
				let _variant_title = $(this).data('variant-title');
				if(variant_title == _variant_title) {
					$(this).val(selVal).selectric('refresh');
				}
			});
		}

		if(selVal == '' || selVal == '0') {
			if($(this).parents('.selector-wrapper').find('.form__errors').length > 0) {
				$(this).parents('.selector-wrapper').find('.form__errors').show();
			}
		} else {
			$(this).parents('.selector-wrapper').find('.form__errors').hide();
		}

		checkHasDisabled($(this));

		calculateGroupPrice();
	});

	$('.add-to-cart').on('click', function(e){
		e.preventDefault();

		var timeStamp = Math.floor(Date.now() / 1000);

		const qty = parseInt($('input[name="quantity"]').val());
		const $selectedProductOption = getProductVariantGroup();

		var params = {};
		var new_properties = {
			"_bundledNo": timeStamp,
			"_bundleMain": true
		};

    $('.group-addon-selector').each(function(){
    	var _addon_id = parseInt($(this).val());
	    var _addon_title = $(this).data('title');
	    var _addon_value = '';
	    var _addon_addable = false;
	    $(this).find('option').each(function(){
	    	let _price = parseInt($(this).data('price'));
	    	if(_addon_id == parseInt($(this).val())) {
		    	if(_price > 0) {
		    		_addon_addable = true;
		    	}
		    	_addon_value = $(this).html();
		    }
	    });

	    // if(!_addon_addable) {
		    new_properties[_addon_title] = _addon_value;
		  // }
    });

		if($('#group-orientation-selector').length > 0) {
			new_properties["orientation"] = $('#group-orientation-selector').val();
	  }

    params = {
      id: $selectedProductOption.val(),
      quantity: qty,
      properties: new_properties
    };

    console.log(params);

    $.ajax({
      url: '/cart/add.js',
      type: 'POST',
      dataType: 'json',
      data: params,
      async: false,
      success: function() {}
    });

    // components and add-ons
    params = [];
		var bundle_properties = {
			"_bundledNo": timeStamp,
			"_bundleMain": false
		};

    var _param = {};
		$('.group-component-selector').each(function(){
			var _component_id = parseInt($(this).val());
			var _comp_index = $(this).data('index');
			var _qty = qty;

			if($('.group-orientation-numbers').length > 0) {
				var _orient_qty = 1;
				$('.group-orientation-numbers').each(function(){
					if(!$(this).parents('.select').hasClass('hidden')) {
						var _orientation = $('#group-orientation-selector').val();
						var _orientation_item = $(this).data('orientation');
						if(_orientation == _orientation_item) {
							_orient_qty = parseInt($(this).val());
						}
					}
				});

				_qty = _qty * _orient_qty;
			}

			var $_variantObj = getComponentVariantObj(_component_id);
			var _component_variant_id = parseInt($_variantObj.val());
			if(_component_variant_id > 0) {
		    _param = {
		      id: _component_variant_id,
		      quantity: _qty,
		      properties: bundle_properties
		    }

		    params.push(_param);
		  }
		});

    $('.group-addon-selector').each(function(){
	    var _addon_id = parseInt($(this).val());
	    var _addon_addable = false;
	    $(this).find('option').each(function(){
	    	let _price = parseInt($(this).data('price'));
	    	if(_addon_id == parseInt($(this).val())) {
		    	if(_price > 0) {
		    		_addon_addable = true;
		    	}
		    }
	    });

	    if(_addon_addable) {
		    _param = {
		      id: _addon_id,
		      quantity: qty,
		      properties: bundle_properties
		    }

		    params.push(_param);
		  }
    });

    for(var i in params) {
    	_param = params[i];

	    $.ajax({
	      url: '/cart/add.js',
	      type: 'POST',
	      dataType: 'json',
	      data: _param,
	      async: false,
	      success: function() {}
	    });
    }

    location.href = '/cart';
	});

	checkAddToCartGroup();
	calculateGroupPrice();
}

/*******
	Selections Overlay
*****/

function toggleSelectionsOverlay() {
	$('body').toggleClass('no-scroll');
	$collectionGroup.find('.overlay__bg').toggleClass('visibled');
	$collectionGroup.find('.product__section-overlay').toggleClass('visibled');

	$collectionGroup.find('select').each(function(){
		checkHasDisabled($(this));
	})
}

function viewSelectionsBoard() {
	let selections = [];
	$('.product__section-overlay select:not(.group-variant-selector, .hidden)').each(function(){
		if(!$(this).parent().hasClass('hidden')) {
			let label = $(this).parents('.selector-wrapper').find('label').text();
			let val = $(this).val();
			let sel_val = '';
			$(this).find('option').each(function(){
				let _opt_val = $(this).val();
				if(_opt_val == val) {
					sel_val = $(this).text();
				}
			});
			let _tmp = {
				label: label,
				value: sel_val
			};
			selections.push(_tmp);
		}
	});

	if(selections.length > 0) {
		$('.form__selections-view ul').html('');
		for(var i =0; i<selections.length; i++) {
			let line_item = selections[i];
			$('.form__selections-view ul').append('<li>' + line_item.label + ': ' + line_item.value + '</li>');
		}
	}
}

function isMakeSelections() {
	if(madeSelection) {
		$('.add-to-cart').prop('disabled', false);
		if(!$('.make-selection').hasClass('hidden')) {
			$('.make-selection').addClass('hidden')
		}
		$('.edit-selection').removeClass('hidden');

		viewSelectionsBoard();
		$('.form__selections-view').removeClass('hidden');
	} else {
		$('.add-to-cart').prop('disabled', true);
		if(!$('.edit-selection').hasClass('hidden')) {
			$('.edit-selection').addClass('hidden')
		}
		$('.make-selection').removeClass('hidden')

		$('.form__selections-view').addClass('hidden');
	}
}

$(document).on('click', '.js-counter .js-counter-plus, .js-counter .js-counter-minus', function(event) {
  event.preventDefault();

  const $this = $(this);
  const $field = $this.parent().find('input');

  let currentValue = Number($field.val());

  if ($this.hasClass('js-counter-plus')) {
    currentValue++;
  }

  if ($this.hasClass('js-counter-minus')) {
    if (currentValue > 0) {
      currentValue--;
    }
  }

  if(currentValue < 1) {
  	currentValue = 1;
  }

  $('input[name="quantity"]').val(currentValue);

	calculateGroupPrice();
});

$(document).on('click', '.make-selection, .edit-selection, .overlay__bg, .close-selections', function(e){
	toggleSelectionsOverlay();
});

$(document).on('click', '.save-selections', function(e){
	let passed = true;
	$('.product__section-overlay select').each(function(i){
		if(!$(this).parents('.select').hasClass('hidden')) {
			if($(this).val() == '' || $(this).val() == '0') {
				passed = false;
			}
		}
	});

	if(passed) {
		madeSelection = true;
		toggleSelectionsOverlay();
	} else {
		madeSelection = false;
	}

	isMakeSelections();
});



// WEBPACK FOOTER //
// ../assets/js/product.js